import Lozenge from '@atlaskit/lozenge';
import Tooltip from '@atlaskit/tooltip';
import { AkEditorWarningIcon } from '@fuegokit/fuegoicons-react';
import { Box } from '@fuegokit/react';
import { useMemo } from 'react';
import styled from 'styled-components';

import { ImportMapping } from '../../../../types';
import { TogglTimeEntry } from '../../../../types/toggl-api';

interface StatusCellProps {
  isSynced: boolean;
  mapping?: ImportMapping | null;
  timeEntry: TogglTimeEntry;
}

export function StatusCell({ isSynced, mapping, timeEntry }: StatusCellProps) {
  const isDurationMismatched = useMemo(() => {
    if (!mapping) {
      return false;
    }
    return (
      timeEntry.duration !== mapping?.timeSpentInSeconds &&
      timeEntry.duration !== mapping?.timeSpentSeconds // this condition is needed for mismatch in
      // property name between timeSpentInSeconds and wrongly named timeSpentSeconds saved by cron job
    );
  }, [timeEntry, mapping]);

  return isSynced ? (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      sx={{ gap: '4px' }}
    >
      <StatusLozenge>
        <Lozenge appearance="success" isBold>
          Synced
        </Lozenge>
      </StatusLozenge>
      {isDurationMismatched && (
        <Box color="icon.warning.default">
          <Tooltip content="Time duration saved in Jira differs from duration saved in Toggl. Please re-sync the entry.">
            <AkEditorWarningIcon fill="icon.warning.default" size={20} />
          </Tooltip>
        </Box>
      )}
    </Box>
  ) : (
    <StatusLozenge>
      <Lozenge maxWidth={82}>Unsynced</Lozenge>
    </StatusLozenge>
  );
}

const StatusLozenge = styled.div`
  span {
    width: fit-content;
    min-width: 74px;
    max-width: 82px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
